export const FB_PIXEL_ACTIONS = {
  TRACK: 'track'
};

export const FB_PIXEL_EVENTS = {
  LEAD_GENERATION: 'Generación de Lead'
};
